import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { antPath } from 'leaflet-ant-path';
import Wkt from 'wicket';
import { fetchShapeByRoute } from '../api/busApi';

const RouteShape = ({ city, routeName }) => {
  const [busGeometryData, setBusGeometryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mapInstance, setMapInstance] = useState(null);

  useEffect(() => {
    const getGeometry = async () => {
      setIsLoading(true);
      try {
        const response = await fetchShapeByRoute(city, routeName);
        setBusGeometryData(response.data);
      } catch (err) {
        console.error(err);
        console.error("routeShape api 請求失敗，將使用預存資料");
        const response = await fetch(`mockResponse/routeShape.json`);
        response.data = await response.json(); 
        setBusGeometryData(response.data);
      } finally {
        setIsLoading(false);
      }
    };

    getGeometry();
  }, [city, routeName]);

  useEffect(() => {
    if (busGeometryData.length > 0 && mapInstance) {
      createPolyLine();
    }
  }, [busGeometryData, mapInstance]);

  const createPolyLine = () => {
    if (!mapInstance) return;
    const tempGeometry = busGeometryData.filter(item => item.RouteName.Zh_tw === routeName);
    if (tempGeometry.length === 0) return;

    const wkt = new Wkt.Wkt();
    const geojsonFeature = wkt.read(tempGeometry[0].Geometry).toJson();
    const reverseLatLng = geojsonFeature.coordinates.map(item => item.reverse());

    const options = {
      paused: false,
      reverse: false,
      delay: 2000,
      dashArray: [10, 20],
      weight: 6,
      color: '#6F00D2',
      opacity: 0.7,
    };

    const antPolyline = antPath(reverseLatLng, options).addTo(mapInstance.target);
    mapInstance.target.fitBounds(antPolyline.getBounds());

    return () => {
      mapInstance.target.removeLayer(antPolyline);
    };
  };

  return (
      <MapContainer
      center={[25.0330, 121.5654]}
      zoom={13}
      style={{ height: '100vh', width: '100%', margin: '20px' }}
      whenReady={setMapInstance}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {isLoading && <div>Loading...</div>}
    </MapContainer>
  );
};

export default RouteShape;
